import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {catchError, Observable, throwError} from 'rxjs';
import {Router} from '@angular/router';
import { LocalStorageService } from './local-storage.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private localStorageService: LocalStorageService,
    private authService: AuthService
  ) {}

  public get(url: string): Observable<any>  {
    const userData: any = localStorage.getItem('currentUser');
    // const headers = new HttpHeaders()
    //   .set('Authorization', `Bearer ${JSON.parse(userData).token}`);

    return this.http.get(url, {
      // headers
    });
  }

  public post(url: string, data: any): Observable<any> {
    // const userData: any = this.localStorageService.getItem('currentUser');
    // const userData: any = this.authService.currentUserValue;
    // console.log('userData', userData);
    // const headers = new HttpHeaders()
      // .set('Authorization', `Bearer ${JSON.parse(userData).token}`);
      // .set('bhs-user-uuid', userData?.uuid || '');

    return this.http.post(url, data,{
      // headers
    }).pipe(catchError((err: any) => {
      if (err.status === 401) {
        this.router.navigateByUrl('/login');
      }
      return throwError(err);
    }));
  }

  public patch(url: string, data: any): Observable<any> {
    // const userData: any = this.localStorageService.getItem('currentUser');
    // const userData: any = this.authService.currentUserValue;
    // console.log('userData', userData);
    // const headers = new HttpHeaders()
      // .set('Authorization', `Bearer ${JSON.parse(userData).token}`);
      // .set('bhs-user-uuid', userData?.uuid || '');

    return this.http.patch(url, data,{
      // headers
    }).pipe(catchError((err: any) => {
      if (err.status === 401) {
        this.router.navigateByUrl('/login');
      }
      return throwError(err);
    }));
  }

  // public put(url: string, data: any): void {
  //
  // }

  public delete(url: string, body?: any): Observable<any> {
    // const userData: any = this.authService.currentUserValue;
    // console.log('userData', userData);
    // const headers = new HttpHeaders()
    // .set('Authorization', `Bearer ${JSON.parse(userData).token}`);
    // .set('bhs-user-uuid', userData?.uuid || '');

    return this.http.delete(url,{
      // headers
    }).pipe(catchError((err: any) => {
      if (err.status === 401) {
        this.router.navigateByUrl('/login');
      }
      return throwError(err);
    }));
  }

  public uploadFile(url: string, formData: any): void {

  }
}
